import React from 'react';
import GargleLogo from '../assets/Gargle-Logo.png';

export const Header = () => {
  return (
    <header style={{
      backgroundColor: '#f8f9fa',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      borderBottom: '1px solid #e2e8f0'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '10px 16px',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <img
          src={GargleLogo}
          alt="Gargle"
          style={{ height: '28px', width: 'auto', maxWidth: '160px' }}
        />
      </div>
    </header>
  );
};
